<template>
  <v-dialog v-model="dialogUpdatePositionLevel" persistent max-width="550px">
    <v-card class="pa-4">
        <v-card-title>
        <span class="dialog-memeber-title">แก้ไขระดับตำแหน่งงาน</span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
        <v-card-text>
          <v-row class="" justify=center>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <!-- แบบเพิ่มตัวเดียว -->
            <v-row>
              <v-col cols="12">
                <span class="mb-0">ชื่อระดับตำแหน่ง</span>
                <v-text-field
                    v-model="namePositionLevel"
                    dense
                    outlined
                    placeholder="ชื่อระดับตำแหน่ง"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-n3">
                <span class="mb-0">เลขระดับ</span>
                <v-text-field
                    v-model.number="numPosition"
                    dense
                    outlined
                    placeholder="เลขระดับ"
                    :rules="[
                        v => { if (v && /^[0-9 ]+$/.test(v)) return true;
                               else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                             }
                    ]"
                    @keydown.space.prevent
                ></v-text-field>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="pr-5 mt-n5 pt-5">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" dark outlined @click="closeDialog()">ยกเลิก</v-btn>
          <v-btn v-if="checkValueList === false" class="button-color ml-5" color="grey" disabled>ยืนยันการแก้ไข</v-btn>
          <v-btn v-else class="button-color ml-5" dark @click="submitData()">ยืนยันการแก้ไข</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import
{
// AddDataPositionNew
  editPositonsLevel
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
export default {
  components: {
  },
  data () {
    return {
      dialogUpdatePositionLevel: false,
      numPosition: '',
      namePositionLevel: '',
      tokenUser: this.$store.state.token,
      id: ''
    }
  },
  beforeDestroy () {
    EventBus.$off('opendialogUpdatePositionLevel')
  },
  mounted () {
    EventBus.$on('opendialogUpdatePositionLevel', this.openDialogUpdatePositionLevel)
  },
  created () {
    // this.initSelectData()
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.requestId = this.$route.params.id
    this.getGroupCompany(this.requestId)
  },
  watch: {
  },
  computed: {
    checkValueList: function () {
      var result = Boolean
      if (this.namePositionLevel === '' || this.numPosition === '') {
        result = false
      } else {
        result = true
      }
      return result
    }
  },
  methods: {
    async getGroupCompany (id) {
      await this.axios({
        method: 'POST',
        url: `${this.api}/api/vMonk/position/positionLvOverview`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          _id: id
        }
      }).then(res => {
        this.namePositionLevel = res.data.result[0].positionLvName
        this.numPosition = res.data.result[0].number
      }).catch(e => {
        console.log(e)
      })
    },
    async submitData () {
      const obj = {
        _id: this.id,
        positionLvName: this.namePositionLevel,
        number: this.numPosition
      }
      try {
        const res = await editPositonsLevel(obj, this.$store.state.token)
        if (!res) {
          swal('ผิดพลาด', 'มีข้อมูลนี้ในระบบแล้ว', 'error', {
            button: false,
            timer: 2000
          })
        } else {
          swal('สำเร็จ', 'แก้ไขข้อมูลระดับตำแหน่งสำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
          EventBus.$emit('closedialogEditPositionLevel')
          this.dialogUpdatePositionLevel = false
        }
      } catch (error) {
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      }
    },
    closeDialog () {
      this.numPosition = ''
      this.namePositionLevel = ''
      this.id = ''
      this.dialogUpdatePositionLevel = false
    },
    openDialogUpdatePositionLevel (value) {
      this.id = value._id
      this.namePositionLevel = value.positionLvName
      this.numPosition = value.number
      this.dialogUpdatePositionLevel = true
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
</style>
